import { Container, Row, Col } from "react-bootstrap";
import { useState } from "react";
import Link from "next/link";
import Swiper from "react-id-swiper";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Image from 'next/image'
import LazyLoad from "react-lazyload";

const Partners = ({ categorySliderData }) => {
  const [swiper, setSwiper] = useState(null);

  const goNext = () => {
    if (swiper !== null) {
      swiper.slideNext();
    }
  };

  const goPrev = () => {
    if (swiper !== null) {
      swiper.slidePrev();
    }
  };

  const params = {
    loop: true,
    slidesPerView: 4,
    grabCursor: true,
    autoplay: {
      delay: 1000
    },
    spaceBetween: 30,
    breakpoints: {
      1024: {
        slidesPerView: 4
      },
      769: {
        slidesPerView: 3
      },
      576: {
        slidesPerView: 2
      },
      320: {
        slidesPerView: 1
      }
    }
  };

  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    // autoplay: true,
    autoplaySpeed: 2000,
    cssEase: "linear",
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };
  const data = [
    { "name": "Emirates Transport", "img": "/assets/images/partners/emirate.webp" },
    { "name": "Al Masaood Automobiles", "img": "/assets/images/partners/masood.webp" },
    { "name": "Insurance Market", "img": "/assets/images/partners/insurance.webp" },
    { "name": "Amazon", "img": "/assets/images/partners/amazon.webp" },
    { "name": "Europcar", "img": "/assets/images/partners/europcar.webp" },
    { "name": "Total Energies", "img": "/assets/images/partners/total-energies.webp" },
  ]
  return (
    <div className="partner" style={{ paddingLeft: '3%', paddingRight: '3%', marginBottom: '20px', marginTop: '35px' }} >
      <Container fluid>
        <Row className="justify-content-center text-center" >
          <Col lg={12} md={12}>
            <div className=" title-anim">
              <div className="header-all">Strategic Partners</div>
            </div>
            <p className="subHead-all " >Find the most reputed brands under Open Bonnet Marketplace</p>
          </Col>
        </Row>
        <Row>
          <Col xs={12} >
            <Slider {...settings}>
              {
                data.map((e, key) => {
                  return (
                    <LazyLoad key={key}>
                      <div className="h-100" style={{ padding: '10px' }}>
                        <div className="partner-slide">
                          <Image alt="strategic partners" src={e.img} height={170} width={305}
                            layout="responsive"
                            style={{ objectFit: 'contain' }} />
                          {/* <div>
                        <div>{e.name}</div>
                      </div> */}
                        </div>
                      </div>
                    </LazyLoad>
                  );
                })}
            </Slider>
            {/* <Swiper {...params} getSwiper={setSwiper}>
                {
                    data.map((e, key) => {
                    return (
                       <div className="partner-slide">
                          <img src={e.img} />
                          <div>
                            <div>{e.name}</div>
                          </div>
                       </div>
                    );
                    })}
                </Swiper> */}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Partners;
